import { render, staticRenderFns } from "./TenantUserSelect.vue?vue&type=template&id=0bf1885a"
import script from "./TenantUserSelect.vue?vue&type=script&lang=ts"
export * from "./TenantUserSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports